module.exports = __webpack_public_path__ + "assets/images/pages/creando/icon-creando-1.png?f0e05be0";